module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      bgblack: _vm.introBG
    }
  }, [_c('transition', {
    attrs: {
      "name": "slideUp"
    }
  }, [(_vm.intro) ? _c('div', {
    staticClass: "welcome",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.enter($event)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "screen"
  }, [_c('visual', {
    attrs: {
      "image": _vm.introImage,
      "background": "cover",
      "role": "img",
      "aria-label": "California African American Museum"
    }
  })], 1), _c('div', {
    staticClass: "logo"
  }, [_c('visual', {
    attrs: {
      "image": "static/logos/caam_logo_white.svg",
      "alt": "Caam Logo"
    }
  })], 1), _c('div', {
    staticClass: "next",
    on: {
      "click": _vm.enter
    }
  }, [_c('visual', {
    attrs: {
      "image": "static/icons/arrow_down_white.svg",
      "alt": "Scroll Arrow"
    }
  })], 1)]) : _vm._e()])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "slideUpOffset"
    }
  }, [(!_vm.intro) ? _c('div', {
    staticClass: "main"
  }, [_c('top-nav', {
    attrs: {
      "headerColor": "black"
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "home"
  }, [_c('div', {
    key: "first",
    staticClass: "screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibition-single',
        params: {
          year: _vm.startYear(_vm.exhibitionFirst),
          id: _vm.exhibitionFirst.uid
        }
      }
    }
  }, [_c('visual', {
    attrs: {
      "image": _vm.exhibitionFirst.mainImage,
      "background": "cover",
      "role": "img",
      "aria-label": _vm.exhibitionFirst.title
    }
  }, [_c('div', {
    staticClass: "captions"
  }, [_c('h2', [_vm._v("exhibition")]), _c('h1', [_vm._v(_vm._s(_vm.title(_vm.exhibitionFirst)))]), _c('h2', [_vm._v(_vm._s(_vm.date(_vm.exhibitionFirst)))])])])], 1)], 1), (!_vm.introBG) ? _c('div', [_vm._l((_vm.exhibitions), function(exhibition) {
    return _c('div', {
      key: _vm.title(exhibition),
      staticClass: "screen"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'exhibition-single',
          params: {
            year: _vm.startYear(exhibition),
            id: exhibition.uid
          }
        }
      }
    }, [_c('visual', {
      attrs: {
        "image": exhibition.mainImage,
        "background": "cover",
        "role": "img",
        "aria-label": exhibition.title
      }
    }, [_c('div', {
      staticClass: "captions"
    }, [_c('h2', [_vm._v("exhibition")]), _c('h1', [_vm._v(_vm._s(_vm.title(exhibition)))]), _c('h2', [_vm._v(_vm._s(_vm.date(exhibition)))])])])], 1)], 1)
  }), _c('div', {
    staticClass: "events"
  }, [_c('h2', [_vm._v("upcoming programs")]), _c('div', {
    staticClass: "eventsContainer"
  }, _vm._l((_vm.programs), function(program) {
    return _c('div', {
      staticClass: "preview"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: _vm.programCategory(program),
            id: program.uid
          }
        }
      }
    }, [_c('visual', {
      attrs: {
        "image": program.mainImage,
        "background": "cover",
        "role": "img",
        "aria-label": program.content.title
      }
    }), _c('div', {
      staticClass: "eventCaptions"
    }, [_c('h1', [_vm._v(_vm._s(program.content.title))]), _c('div', {
      staticClass: "dateTime"
    }, [_c('h2', [_vm._v(_vm._s(program.content.date))]), _c('p', [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])])], 1)], 1)
  }))]), _c('div', {
    staticClass: "explore"
  }, [_c('h2', [_vm._v("explore")]), _c('div', {
    staticClass: "exploreContainer"
  }, [_c('swiper', {
    ref: "gallery",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.explore), function(item) {
    return _c('swiper-slide', {
      key: item.text
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_c('visual', {
      attrs: {
        "image": item.image_url,
        "background": "cover",
        "role": "img",
        "aria-label": item.text
      }
    }), _c('h2', [_vm._v(_vm._s(item.text))])], 1)])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2)], 1)])], 2) : _vm._e()]) : _vm._e()]), (!_vm.introBG) ? _c('bottom-nav', {
    attrs: {
      "footerColor": "black"
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf08904"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 224
// module chunks = 1